import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {StreamupComponent} from './streamup.component';
import {SmsComposeComponent} from './sms-center/sms-compose.component';
import {WebsitePromosComponent} from './website-control-center/promotions/website-promos.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import {MySitesComponent} from './website-control-center/my-sites/my-sites.component';
import {WhmcsComponent} from './whmcs/whmcs.component';
import {Html5playersComponent} from './html5players/html5players.component';
import {AboutComponent} from './about/about.component';
import {UnderDevelopmentComponent} from './under-development/under-development.component';
import {VultrComponent} from './vultr/vultr.component';

const routes: Routes = [
  {
    path: '',
    component: StreamupComponent,
    children: [
      {
        path: 'dashboard',
        component: DashboardComponent
      },
      {
        path: 'sms',
        component: SmsComposeComponent
      },
      {
        path: 'whmcs',
        component: WhmcsComponent
      },
      {
        path: 'wcc/sites',
        component: MySitesComponent
      },
      {
        path: 'wcc/promos',
        component: WebsitePromosComponent
      },
      {
        path: 'vultr',
        component: VultrComponent
      },
      {
        path: 'html5players',
        component: Html5playersComponent
      },
      {
        path: 'user-profile',
        component: UnderDevelopmentComponent
      },
      {
        path: 'about',
        component: AboutComponent
      },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: '**', redirectTo: 'dashboard', pathMatch: 'full' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class StreamupRoutingModule {}
